// Import model
import { FilterLeadRequest } from '../models/FilterLeadRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { LeadCondition } from '../models/LeadCondition';
import { LeadFields } from '../models/LeadFields';
import { LeadIndexedFields } from '../models/LeadIndexedFields';

// Import dependency serializers (for complex types)
import { LeadConditionSerializer } from './LeadConditionSerializer';
import { LeadFieldsSerializer } from './LeadFieldsSerializer';
import { LeadIndexedFieldsSerializer } from './LeadIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLeadRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterLeadRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLeadRequest instance
   */
  static deserialize(json: string): FilterLeadRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLeadRequest instance
   */
  static fromObject(obj: any): FilterLeadRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLeadRequest');
    }


    const instance: FilterLeadRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as LeadIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as LeadFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        LeadConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLeadRequest instances
   */
  static deserializeArray(json: string): FilterLeadRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLeadRequest instance to a JSON string
   */
  static serialize(instance: FilterLeadRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLeadRequest instance to a plain object
   */
  static toObject(instance: FilterLeadRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        LeadConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLeadRequest instances to a JSON string
   */
  static serializeArray(instances: FilterLeadRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
